import _defineProperty from "@babel/runtime/helpers/defineProperty";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from "react";
import pick from "lodash/pick";
import { defaultCurrency } from "@zapier/currency/esm/hooks/useCurrencies";
import { RoundingStrategy, formatPrice, formatPriceToBeInCurrency } from "@zapier/currency/esm/utils/formatPriceToBeInCurrency";
function getFormattedPrice(price, meta) {
  const {
    isLocalized,
    currency,
    roundingStrategy
  } = meta;
  const formattingOptions = _objectSpread(_objectSpread({}, pick(meta, ["minDecimals", "maxDecimals"])), {}, {
    useRelativeRounding: false
  });

  /**
   * Zero-decimal currencies need their price rounded based on a given strategy
   * They also need to be treated as whole dollars and not cents (avoid division by 100)
   */
  if (currency.zeroDecimal) {
    formattingOptions.isPriceGivenAsCents = !isLocalized;
    formattingOptions.roundingStrategy = roundingStrategy !== null && roundingStrategy !== void 0 ? roundingStrategy : RoundingStrategy.default;
  }
  return isLocalized ? formatPrice(price, formattingOptions) : formatPriceToBeInCurrency(price, currency, false, formattingOptions);
}

/**
 * Displays a price in a user-friendly format
 */
export const Price = ({
  children,
  currency = defaultCurrency,
  hideCurrencyName = false,
  maxDecimals = 2,
  minDecimals = 0,
  symbolFontSize = "inherit",
  isLocalized = false,
  roundingStrategy
}) => {
  const absPrice = Math.abs(children);
  const isNegative = children < 0;
  const price = getFormattedPrice(absPrice, {
    currency,
    isLocalized,
    maxDecimals,
    minDecimals,
    roundingStrategy
  });
  const currencyName = !hideCurrencyName && (currency === null || currency === void 0 ? void 0 : currency.symbol) === "$" ? currency === null || currency === void 0 ? void 0 : currency.name : "";
  return __jsx("span", {
    style: {
      alignItems: "center",
      display: "inline-flex"
    }
  }, isNegative && __jsx("span", null, "-"), __jsx("span", {
    style: {
      fontSize: symbolFontSize
    }
  }, currency.symbol), __jsx("span", null, `${price} ${currencyName}`.trim()));
};
//# sourceMappingURL=Price.js.map